<mat-card>
  <p>{{ title }}</p>
  <div class="button" (click)="click()">
    <mat-icon>{{ icon }}</mat-icon>
    {{ body }}
  </div>
</mat-card>
